import { EStyleSheet as Api } from './EStyleSheet';
export const EStyleSheet = new Api();
export * from './hooks/dynamicStyleHook';
export * from './types';
